import React, { useState } from 'react';

const CustomCheckbox = ({ label, checked, onChange, isStatusDisplayed, error, ...props }) => {
  const checkboxClassName = `custom-checkbox ${isStatusDisplayed && error ? "custom-checkbox-danger" : "" }`;

  const handleChange = (e) => {
    onChange && onChange(e);
  };

  const uniqueId = `checkbox_${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={checkboxClassName}>
      <input type="checkbox" id={uniqueId} checked={checked} onChange={handleChange} {...props} />
      <label className='label' htmlFor={uniqueId}>{label}</label>
    </div>
  );
};

export default CustomCheckbox;